import { lazy } from 'react';

const FreeToPlay = lazy(() => import(/* webpackChunkName: "freeToPlay" */ './free-to-play-container'));

export default FreeToPlay;
